import get from 'lodash/get';

const getDisplayMedia = get(
  global,
  'navigator.getDisplayMedia',
  get(global, 'navigator.mediaDevices.getDisplayMedia')
);

export default (typeof getDisplayMedia === 'function');
